import { Card } from "primereact/card";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Button } from "primereact/button";
import React, { useEffect, useRef, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { JVDate } from "../../../shared/JVDate";
import { ICompanyMastDropdown, IBranchMastDropdown, IUsersDropdown } from "../../../models/IDropdown";
import { IPermissionProps, ILogin } from "../../../models/Login";
import { Fetch, baseUrl } from "../../../shared/Fetch";
import { JVDropdown } from "../../../shared/JVDropdown";
import { JVInput } from "../../../shared/JVInput";
import { ColumnGroup } from 'primereact/columngroup';
import { Row } from 'primereact/row';
import { JVCheckbox } from "../../../shared/JVCheckbox";
import { SubTable } from "./SubTable";
import { Toolbar } from "primereact/toolbar";
import { AssignedSalesForm } from "./AssignedSales";

interface IPrimeVendorPerformanceReports {
    fromDate?: Date | null,
    toDate?: Date | null,
    prime_Vendor?: string | null,
    company_ID?: number | null,
    branch_ID?: number | null,
    salesManager_ID?: number | null,
    vendor_Company_ID?: number | null,
    isFilter?: number | null,
    frequency?: number | null,
    show_POC?: boolean | null,
    inActiveClient?: boolean | null,



}

interface IPrimeVendorPerformanceReportsTableData {
    vendor_Company_Name: string,
    req: number,
    sub: number,
    subEnd: number,
    eci: number,
    po: number,
}

const EmptyPrimeVendorPerformanceReports: IPrimeVendorPerformanceReports = {
    fromDate: null,
    toDate: null,
    prime_Vendor: "",
    company_ID: null,
    branch_ID: null,
    salesManager_ID: null,
    vendor_Company_ID: null,
    show_POC: null,
    inActiveClient: null
}

const schema = yup.object({
    fromDate: yup.date().nullable(),
    toDate: yup.date().nullable(),
    prime_Vendor: yup.string().nullable(),
    company_ID: yup.number().nullable(),
    branch_ID: yup.number().nullable(),
    salesManager_ID: yup.number().nullable(),
    vendor_Company_ID: yup.number().nullable(),
    frequency: yup.number().nullable(),
});

export const InActivePVReport = (permissions: IPermissionProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [salesManager, setSalesManager] = useState<Array<IUsersDropdown>>();
    const [loadIcon, setLoadIcon] = useState(false);
    const [filter, setFilter] = useState<IPrimeVendorPerformanceReports>();
    const [shwSubTable, setShwSubTable] = useState({ singleData: {}, open: false } as { singleData: any, open: boolean });
    const [tFooter, setTFooter] = useState<any>({});
    const [selectedClient, setSelectedClient] = useState<any>();
    const [openAssignSales, setOpenAssignSales] = useState(false);

    const [excel, setExcel] = useState<boolean>(false);
    const [excelNum, setExcelNum] = useState<number | null>(0);
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const { control, handleSubmit, formState: { errors }, reset, watch, setValue } = useForm<IPrimeVendorPerformanceReports>({
        resolver: yupResolver(schema),
        defaultValues: EmptyPrimeVendorPerformanceReports,
        shouldFocusError: false
    });

    const showPOC = watch("show_POC");
    const inActiveClient = watch("inActiveClient");


    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/reqCompanyList", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            const emptyData = {
                company_ID: 0,
                company_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setCompanies(data);
        }
    }
    const loadBranches = async (company?: number | null | undefined) => {
        let queryParam = company ? `company_id=${company}` : null;
        const response = await Fetch("Dropdown/reqBranchList", "GET", null, queryParam, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            const emptyData = {
                branch_ID: 0,
                branchName: "-- SELECT --",
                company_ID: 0
            };
            data.unshift(emptyData);
            setBranches(data);
        }
    }
    const loadSales = async (branch: number | null | undefined, company: number | null | undefined, team: number | null | undefined) => {
        let queryParameter = null;
        if (branch != 0 && branch != null) {
            queryParameter = `branch_ID=${branch}`;
        } else if (company != 0 && company != null) {
            queryParameter = `company_ID=${company}`;
        } else if (team != 0 && team != null) {
            queryParameter = `team_ID=${team}`;
        }

        const response = await Fetch("Dropdown/SalesManagerList", "GET", null, queryParameter, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            const emptyData = {
                login_ID: 0,
                user_Name: "-- SELECT --"
            };
            data.unshift(emptyData);
            setSalesManager(data);
        }
    }


    useEffect(() => {
        loadSales(0, 0, 0);
        loadCompanies();
        loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "company_ID") {
                if (value.company_ID != 0) {
                    loadBranches(value.company_ID);
                    loadSales(0, value.company_ID, 0);
                } else {
                    loadBranches();
                    if (value.branch_ID != 0) {
                        loadSales(value.branch_ID, 0, 0);
                    } else {
                        loadSales(0, 0, 0);
                    }
                }
            }

            if (name === "branch_ID") {
                if (value.branch_ID != 0) {
                    loadSales(value.branch_ID, 0, 0);
                } else {
                    if (value.company_ID != 0) {
                        loadSales(0, value.company_ID, 0);
                    } else {
                        loadSales(0, 0, 0);
                    }
                }
            }

            if (name === "frequency") {
                if (value.frequency != 0 && value.frequency != null) {
                    setExcelNum(prev => prev = value?.frequency || 0);
                    setExcel(prev => prev = true);
                } else {
                    setExcel(prev => prev = false);
                    setExcelNum(prev => prev = null);
                }
            }
        });

        return () => subscription.unsubscribe();
    }, [watch]);

    const loadTableDate = async (body: any) => {
        setTableData({ tableData: tableData.tableData, loading: true });
        setLoadIcon(true);
        setFilter(body);
        const response = await Fetch("InActivePrimeVendor", "GET", null, `filter=${JSON.stringify(body)}`, null);
        if (response) {
            const data: Array<any> = await response.json();
            let totalNoOfReq = 0;
            let totalNoOfSub = 0;
            let totalNoOfSubClient = 0;
            let totalNoOfECI = 0;
            let totalNoOfPO = 0;
            let totalNoOfReqM = 0;
            let totalNoOfSubM = 0;
            let totalNoOfSubClientM = 0;
            let totalNoOfECIM = 0;
            let totalNoOfPOM = 0;
            let totalNoOfReqT = 0;
            let totalNoOfSubT = 0;
            let totalNoOfSubClientT = 0;
            let totalNoOfECIT = 0;
            let totalNoOfPOT = 0;

            data.forEach((d, i) => {
                if (d.totalReq) totalNoOfReq += d.totalReq;
                if (d.totalSub) totalNoOfSub += d.totalSub;
                if (d.totalSubEnd) totalNoOfSubClient += d.totalSubEnd;
                if (d.eciTotal) totalNoOfECI += d.eciTotal;
                if (d.totalPO) totalNoOfPO += d.totalPO;
                if (d.totalReqMonth) totalNoOfReqM += d.totalReqMonth;
                if (d.monthSub) totalNoOfSubM += d.monthSub;
                if (d.monthSubEnd) totalNoOfSubClientM += d.monthSubEnd;
                if (d.eciMonth) totalNoOfECIM += d.eciMonth;
                if (d.totalPOM) totalNoOfPOM += d.totalPOM;
                if (d.totalReqToday) totalNoOfReqT += d.totalReqToday;
                if (d.todaySub) totalNoOfSubT += d.todaySub;
                if (d.todaySubEnd) totalNoOfSubClientT += d.todaySubEnd;
                if (d.eciToday) totalNoOfECIT += d.eciToday;
                if (d.totalPOT) totalNoOfPOT += d.totalPOT;
            });
            const totalRecords: any = {
                total: "Total Records",
                noOfReq: totalNoOfReq,
                noOfSub: totalNoOfSub,
                noOfSubClient: totalNoOfSubClient,
                noOfECI: totalNoOfECI,
                noOfPO: totalNoOfPO,
                noOfReqM: totalNoOfReqM,
                noOfSubM: totalNoOfSubM,
                noOfSubClientM: totalNoOfSubClientM,
                noOfECIM: totalNoOfECIM,
                noOfPOM: totalNoOfPOM,
                noOfReqT: totalNoOfReqT,
                noOfSubT: totalNoOfSubT,
                noOfSubClientT: totalNoOfSubClientT,
                noOfECIT: totalNoOfECIT,
                noOfPOT: totalNoOfPOT
            };
            setTFooter(totalRecords);
            setTableData({ tableData: data, loading: false });
            setLoadIcon(false);
        }
    };

    const onSubmit = (data: IPrimeVendorPerformanceReports) => {
        let newDate = new Date;
        if (data.fromDate?.toDateString() !== newDate.toDateString() || (data.prime_Vendor !== null && data.prime_Vendor !== "") || (data.company_ID !== null && data.company_ID !== 0) || (data.branch_ID !== null && data.branch_ID !== 0) || (data.salesManager_ID !== null && data.salesManager_ID !== 0) || (data.vendor_Company_ID !== null && data.vendor_Company_ID !== 0)) {
            data.isFilter = 1;
        } else {
            data.isFilter = null;
        }

        delete data.frequency;

        loadTableDate(data);
    };



    const exportCSV = () => {
        dt.current.exportCSV();
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center flex justify-content-between bg-white">
            <h5 className="m-0">IN Active Client Performance Reports</h5>
            {permissions.is_Export && <Button label="Export" icon="pi pi-upload" className="p-button-help my-2" onClick={exportCSV} />}
        </div>
    );

    const onClear = () => {
        reset(EmptyPrimeVendorPerformanceReports);
        setExcel(false);
        setExcelNum(0);
    }


    useEffect(() => {
        loadTableDate(EmptyPrimeVendorPerformanceReports);
    }, []);

    const hideDialog = () => {
        setShwSubTable({ singleData: {}, open: false });
    }

    const onHideAssignedUpdateForm = () => {
        setOpenAssignSales(false);
        setSelectedClient([]);
    };

    const rightToolbarTemplate = () => {
        return (
            <Button
                label="Assign Sales Manager"
                onClick={() => {
                    if (selectedClient && selectedClient.length > 1) {
                        setOpenAssignSales(true);
                    } else {
                        toast.current.show({
                            severity: 'warn',
                            detail: 'Please select at least 2 invoices to update multiple invoice.',
                            life: 3000,
                        });
                    }
                }}
            />
        );
    };


    return (
        <>
            <Card>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                    <JVDate column={6} label="From Date" control={control} name="fromDate" />
                    <JVDate column={6} label="To Date" control={control} name="toDate" />
                    <JVInput column={6} label="Prime Vendor:" control={control} name="prime_Vendor" placeholder="Enter Prime Vendor" error={errors.prime_Vendor?.message} />

                    {(_roles.includes(4) || _roles.includes(5) || _roles.includes(1) || _roles.includes(46)) && <JVDropdown column={6} label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" />}
                    {(_roles.includes(4) || _roles.includes(5) || _roles.includes(1) || _roles.includes(46)) && <JVDropdown column={6} label="Branch" control={control} name="branch_ID" options={branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" />}
                    {/* <JVDropdown column={6} label="Sales Manager" control={control} name="salesManager_ID" options={salesManager} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" /> */}
                    {/* <JVCheckbox column={4} label="Show ECI" control={control} name="show_POC" /> */}
                    <JVCheckbox column={4} label="InActive Client" control={control} name="inActiveClient" />

                    <div className="col-12 md:col-12">
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px' }}>
                            <Button className="field col-12 md:col-6" label="FIND" type="submit" loading={loadIcon}></Button>
                            <Button className="field col-12 md:col-6 p-button-outlined" label="CLEAR" onClick={onClear} type="button"></Button>
                        </div>
                    </div>
                </form>
            </Card>
            <Toolbar className="mb-1 py-0" right={rightToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                resizableColumns
                ref={dt} size="small" scrollable scrollHeight="70vh"
                value={tableData.tableData}
                header={header}
                loading={tableData.loading}
                selection={selectedClient}
                onSelectionChange={(e) => {
                    setSelectedClient(e.value);

                }}
                selectionMode="multiple"
                dataKey="vendor_Company_ID"
            //  headerColumnGroup={headerGroup}
            >
                {<Column selectionMode="multiple" />}

                <Column header="SN." body={(data, options) => options.rowIndex + 1} style={{ maxWidth: '4rem' }} footer={""} />
                <Column field="vendor_Company_Name" header="Prime Vendor" sortable footer={tFooter.total} style={{ maxWidth: '10rem' }} />
                {/* <Column field="contact_Person_Name" header="Client" sortable /> */}
                <Column field="totalReq" header="Req" footer={tFooter.noOfReq} className="bg-cyan-100" style={{ marginLeft: "2rem" }} />
                <Column field="totalSub" header="Sub" footer={tFooter.noOfSub} className="bg-cyan-100" />
                <Column field="totalSubEnd" header="ECS" footer={tFooter.noOfSubClient} className="bg-cyan-100" />
                <Column field="eciTotal" header="ECI" footer={tFooter.noOfECI} className="bg-cyan-100" />
                <Column field="totalPO" header="PO" footer={tFooter.noOfPO} className="bg-cyan-100" />
                {/* 
                <Column field="totalReqMonth" header="Req Month" footer={tFooter.noOfReqM} className="bg-green-200" />
                <Column field="monthSub" header="Sub Month" footer={tFooter.noOfSubM} className="bg-green-200" />
                <Column field="monthSubEnd" header="ECS" footer={tFooter.noOfSubClientM} className="bg-green-200" />
                <Column field="eciMonth" header="ECI Month" footer={tFooter.noOfECIM} className="bg-green-200" />
                <Column field="totalPOM" header="PO Month" footer={tFooter.noOfPOM} className="bg-green-200" />

                <Column field="totalReqToday" header="Req Today" footer={tFooter.noOfReqT} className="bg-yellow-200" />
                <Column field="todaySub" header="Sub Today" footer={tFooter.noOfSubT} className="bg-yellow-200" />
                <Column field="todaySubEnd" header="ECS" footer={tFooter.noOfSubClientT} className="bg-yellow-200" />
                <Column field="eciToday" header="ECI Today" footer={tFooter.noOfECIT} className="bg-yellow-200" />
                <Column field="totalPOT" header="PO Today" footer={tFooter.noOfPOT} className="bg-yellow-200" /> */}

            </DataTable>
            <AssignedSalesForm tableData={selectedClient} open={openAssignSales} hideDialoge={() => onHideAssignedUpdateForm()} toast={toast} />

            <SubTable open={shwSubTable.open} singleData={shwSubTable.singleData} hideDialog={hideDialog} toast={toast} />
            <Toast ref={toast} />
        </>
    );
}